import { layers } from '@atlassian/jira-common-styles/src';

type CSSProperties = Partial<CSSStyleDeclaration>;
export const customStyles = {
	menu: (base: CSSProperties) => ({
		...base,
		zIndex: layers.modal,
	}),
	menuPortal: (base: CSSProperties) => ({
		...base,
		zIndex: layers.modal,
	}),
} as const;
